import React from 'react'
import { Box, Button, Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { Item, SuccessPopUp1 } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import Datepicker from '../../../../common/datePicker'
import { SplitButton } from '../../../../common/SplitButton'
import { RefreshSvg } from '../../../../common/svg/refresh'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as id from '../../reportId'
import * as lb from '../../reportLables'
import { useState } from 'react'
import OwnBookingSummary from './OwnBookingSummary'
import OwnBookingDetailed from './OwnBookingDetailed'
import { paymentModesWithAll } from '../../../../common/paymentsMode'
import { getOwnBookingFilterData, getOwnBookingTableData, getCargoSettingFilterData } from '../../../../../store/reports/reports_action'
import { connect } from 'react-redux'
import { lrStatusView, reportView, transType } from '../../../../common/constants'
import { useEffect } from 'react'
import moment from 'moment/moment'
import { navigation3, appendToUrl, diffInMonths, focusElemnt, isEmpty, removeDuplicatesFromArray } from '../../../../common/helper'
import * as urls from '../../oldReportsUrls'
import { updateAlert, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { ownBookingDetailedColumnsWithFormattedLRTwo, ownBookingDetailedColumnsForPotrate, OwnBookingDetailedExcelHeader, bookingSummaryColumn, ownBookingDetailedColumnsForLeyma } from '../BookingConstants'
import ManageColumns from '../../../../common/ManageColumnsUI'
import { devideInTwoIntegers, divideInNIntegers } from '../../../../common/mathHelper'
import { GT_COMPANY_ID, LEYMA_CARGO, MY_BUS } from '../../../../../helper/companyIdhardcode'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../../common/jotaiState/reportStateAtom'
import { useAtom } from 'jotai'

const OwnBookings = (props) => {
  const {
    data: { common, reports },
    getOwnBookingFilterData,
    getOwnBookingTableData,
    getCargoSettingFilterData,
    updateAlert,
    updateAlertError,
    updateModal
  } = props
  const { loginData, roleRights, showModal, modalType, companySettings } = common
  const { AllowGroupofCompanies = 0 } = roleRights?.Table1?.[0] || {}
  const { intCompanyID,intUserID } = loginData
  const loginCountryId = companySettings[0]?.DefaultCurrencyID
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
  const BookingReportPortrait = companySettings?.[0]?.BookingReportPortrait || 0
  const { ownBookingDropData, ownBookingTableData, cargoSettingFilterData } = reports
  const { DefaultCurrencyID, IsHamaliInBookingReport, UseToPayAsCOD } = companySettings?.[0] || {}
  const summaryheaders = bookingSummaryColumn.filter(col => {
    if (DefaultCurrencyID === 2 && col.field === 'BookingGST') return false;
    if (!IsHamaliInBookingReport && col.field === 'HamaliCharges') return false;
    return true;
  }).map(col => {
    if (col.field === 'Valuation') {
      return {
        ...col,
        headerName: DefaultCurrencyID === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
        exportHead: DefaultCurrencyID === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
      };
    }
    if(col.field === 'CartageAmount' &&loginData?.intCompanyID===GT_COMPANY_ID){
      return {
        ...col,
        headerName: 'Addl. \nCartage',
        exportHead: 'Addl. \nCartage',
      };
    }
    return col;
  });
  const [clickButton, setClickButton] = useState('')
  const [showReport, setShowReport] = useState(false)
  const [tableData, setTableData] = useState([])
  const [manageColumn, setManageColumn] = useState([])
  const [selCompany, setSelCompany] = useState('')
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))

  const [sourceCity, setSourceCity] = useState('')
  const [sourceCityData, setSourceCityData] = useState([])

  const [sourceBranch, setSourceBranch] = useState('')
  const [sourceBranchData, setSourceBranchData] = useState([])

  const [sourceBranchUser, setSourceBranchUser] = useState('')
  const [sourceBranchUserData, setSourceBranchUserData] = useState([])

  const [destinationCity, setDestinationCity] = useState('')
  const [destinationCityData, setDestinationCityData] = useState([])
  const [destinationBranch, setSelDestinationBranch] = useState('')
  const [destinationBranchdata, setSelDestinationBranchdata] = useState([])

  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [transactionType, setTransactionType] = useState(transType?.[0])
  const [selReportView, setSelReportView] = useState(reportView?.[1])
  const [status, setStatus] = useState(lrStatusView?.[0])
  const [checkCrossinglr, setCheckCrossinglr] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  const headerData = {
    sourceCity: sourceCity?.SourceCityName,
    sourceBranch: sourceBranch?.SourceBranchName,
    sourceBranchUser: sourceBranchUser?.UserBooked,
    destCity: destinationCity?.DestCityName,
    destBranch: destinationBranch?.DestBranchName,
    paymentType: paymentType?.name,
    trnsType: transactionType?.TransType,
    status: status?.LrStatus,
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSourceCity(' ')
    setSourceBranch(' ')
    setSourceBranchUser(' ')
    setDestinationCity(' ')
    setSelDestinationBranch(' ')
    setPaymentType([paymentModesWithAll?.[0]])
    setTransactionType(transType?.[0])
    setSelReportView(reportView?.[1])
    setStatus(lrStatusView?.[0])
    setCheckCrossinglr(false)
  }
  const handleGoClick = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      setClickButton('Go')
      const obj = {
        CompanyID: selCompany?.CompanyID,
        FromDate: moment(fromDate).format('YYYY-MM-DD'),
        ToDate: moment(toDate).format('YYYY-MM-DD'),
        FranchCompID: 0,
      }
      getOwnBookingFilterData(obj)
    }
  }
  const handleClick1 = () => {
    if (sourceCity == "" || sourceCity == ' ') {
      updateAlertError({ show: true, msg: 'Select Source City', nextId: '' })
    } else if (sourceBranch == "" || sourceBranch == ' ') {
      updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' })
    } else if (sourceBranchUser == "" || sourceBranchUser == ' ') {
      updateAlertError({ show: true, msg: 'Select Branch User', nextId: '' })
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      setShowReport(true)
      setClickButton('Generate')
      const object = {
        CompanyID: selCompany?.CompanyID,
        SourceCityID: sourceCity?.SourceCityID || 0,
        SourceBranchID: sourceBranch?.SourceBranchID || 0,
        DateFrom: moment(fromDate).format('YYYY-MM-DD'),
        DateTo: moment(toDate).format('YYYY-MM-DD'),
        UserID: sourceBranchUser?.UserID || 0,
        DestCityID: destinationCity?.DestCityID || 0,
        DestBranchID: destinationBranch?.DestBranchID || 0,
        PaymentTypeIDs: paymentType.typeId || 0,
        Mode: transactionType?.TransId || 0,
        StatusCode: status?.LrId || 0,
        IsCrossingCity: checkCrossinglr ? 1 : 0,
        LoggedInUser: loginData?.intUserID,
        AllowViewAllReport: 1,
      }
      getOwnBookingTableData(object,UseToPayAsCOD)
    }
  }
  const handleClick2 = () => {
    if (transactionType?.TransId === 1) {
      updateAlert({ show: true, msg: 'Booked Trans. Not Allowed' })
    } else if (destinationBranch.DestBranchID != 0) {
      updateAlert({ show: true, msg: `Please Select All Destination Branch and Try Again.` })
    } else if (diffInMonths(fromDate, toDate) !== 0) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      let url = urls.BookingReport
      let urlData = urls.BookingReportParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.dtDateFrom = fromDate.format('DD-MMM-YYYY')
      urlData.dtDateTo = toDate.format('DD-MMM-YYYY')
      urlData.intCompanyId = loginData?.intCompanyID
      urlData.intBranchId = sourceBranch.SourceBranchID || 0
      urlData.intpaymenttype = paymentType.typeId
      urlData.intUserId = sourceBranchUser?.UserID || 0
      urlData.intLoggedInUSer = loginData?.intUserID
      urlData.Isrefund = transactionType?.TransId ? 2 : 0 //based on AllTransiction Dropdown
      urlData.intAllowViewAllReport = 1
      urlData.companyname = loginData.strCompanyName
      urlData.intDestCityId = destinationCity.DestCityID || 0
      urlData.strDestCityName = destinationCity.DestCityID === 0 ? "--All--" : destinationCity.DestCityName
      urlData.isSummaryOnly = selReportView?.ReportId === "0" ? 1 : 0
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }
  useEffect(() => {
    focusElemnt("fromDate")
  }, [])
  useEffect(() => {
    let updatedOptions = paymentModesWithAll.map(item => ({ ...item }));
    if (UseToPayAsCOD === 1) {
      const toPayIndex = updatedOptions.findIndex(item => item.typeId === 2);
      const codOption = updatedOptions.find(item => item.typeId === 4);
      if (toPayIndex !== -1 && codOption) {
        updatedOptions[toPayIndex] = {
          ...codOption,
          typeId: 2,
          name: "COD",
          roleRightsId: "COD"
        };
      }
      updatedOptions = updatedOptions.filter(item => item.typeId !== 4);
    }
    setPaymentOptions(updatedOptions);
  }, [UseToPayAsCOD]);
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID,
      }
      getCargoSettingFilterData(obj)
      const body={
        intCompanyID:intCompanyID,
        UserID:intUserID
      }
      fetchChildCompanyList(body)
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
      setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
      // setDisableBtn(true)
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (ownBookingDropData.status === 'Success') {
      if (ownBookingDropData?.Data?.Table?.length >= 1) {
        const SourceCity = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({ SourceCityName: val.SourceCityName, SourceCityID: val.SourceCityID }))
          ),
        ]
        const SourceBranch = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({
              SourceBranchName: val.SourceBranchName,
              SourceBranchID: val.SourceBranchID,
              SourceCityID: val.SourceCityID,
            }))
          ),
        ]
        const SourceBranchUser = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({
              UserBooked: val.UserBooked,
              UserID: val.UserID,
              SourceBranchID: val.SourceBranchID,
            }))
          ),
        ]
        const DestinationCity = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({
              DestCityName: val.DestCityName,
              DestCityID: val.DestCityID,
              SourceCityID: val.SourceCityID,
            }))
          ),
        ]
        const DestinationBranch = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({
              DestBranchName: val.DestBranchName,
              DestBranchID: val.DestBranchID,
              DestCityID: val.DestCityID,
            }))
          ),
        ]
        // if (!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin)) {
        if (disableBtn) {
          setSourceCity({ SourceCityName: loginData.strCityName, SourceCityID: loginData.intBranchCityID })
          if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1) {
            const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === loginData?.intBranchID)
            const selectedUser = SourceBranchUser?.filter((val) => val.UserID === loginData?.intUserID)
            if (selectedBranch?.length > 0) {
              setSourceBranch(selectedBranch?.[0])
            } else {
              setSourceBranch({ SourceBranchName: 'All Branch', SourceBranchID: 0 })
            }
            if (selectedUser?.length > 0) {
              setSourceBranchUser(selectedUser?.[0])
            } else {
              setSourceBranchUser({ UserBooked: 'All Branch User', UserID: 0 })
            }
          } else {
            setSourceBranch({ SourceBranchName: loginData.strBranchName, SourceBranchID: loginData.intBranchID })
            setSourceBranchUser({ UserBooked: loginData.strUserName, UserID: loginData.intUserID })
          }
        } else {
          const selectedCity = SourceCity?.filter((val) => val.SourceCityID === loginData?.intBranchCityID)
          const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === loginData?.intBranchID)
          const selectedUser = SourceBranchUser?.filter((val) => val.UserID === loginData?.intUserID)
          if (selectedCity?.length > 0) {
            setSourceCity(selectedCity?.[0])
          } else {
            setSourceCity({ SourceCityName: 'All Cities', SourceCityID: 0 })
          }
          if (selectedBranch?.length > 0) {
            setSourceBranch(selectedBranch?.[0])
          } else {
            setSourceBranch({ SourceBranchName: 'All Branch', SourceBranchID: 0 })
          }
          if (selectedUser?.length > 0) {
            setSourceBranchUser(selectedUser?.[0])
          } else {
            setSourceBranchUser({ UserBooked: 'All Branch User', UserID: 0 })
          }
        }
        setSourceCityData([{ SourceCityName: 'All Cities', SourceCityID: 0 }, ...SourceCity])
        setSourceBranchData([{ SourceBranchName: 'All Branch', SourceBranchID: 0 }, ...SourceBranch])
        setSourceBranchUserData([{ UserBooked: 'All Branch User', UserID: 0 }, ...SourceBranchUser])
        setDestinationCityData([{ DestCityName: 'All Cities', DestCityID: 0 }, ...DestinationCity])
        setSelDestinationBranchdata([{ DestBranchName: 'All Branch', DestBranchID: 0 }, ...DestinationBranch])
        setDestinationCity({ DestCityName: 'All Cities', DestCityID: 0 })
        setSelDestinationBranch({ DestBranchName: 'All Branch', DestBranchID: 0 })
      } else {
        setSourceCityData([])
      }
    }
  }, [ownBookingDropData])
  useEffect(() => {
    if (AllowGroupofCompanies === 1) {
      const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === loginData.intCompanyID) || ChildCompanyList[0]
      setSelCompany(defaultCompany)
    } else {
      setSelCompany({
        CompanyID: loginData.intCompanyID,
        CompanyName: loginData.strCompanyName,
      })
    }
  }, [ChildCompanyList, AllowGroupofCompanies])
  const groupData = (arr = [],headers) => {
    const lengths = divideInNIntegers(headers.length, 3)
    let index = 0
    const pickedHeaders = []
    lengths.forEach((span) => {
      pickedHeaders.push(headers[index].field)
      index += span
    })

    const grouped = {};

    // Step 1: Group by IsRefund and PaymentMode
    arr = arr.map((v, i) => ({
      ...v,
      Valuation: Math.round(v.Valuation) || 0,
      CartageAmount: Math.round(v.CartageAmount) || 0,
    }))
    arr.forEach((val) => {
      const key = `${val.IsRefund}-${val.PaymentMode}`;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(val);
    });

    const transform = (list) =>
      list.map((val, i) => ({
        ...val,
        srNo: i + 1,
        dataType: 'entry',
        'Sender^^SenderGSTN': `${val.Sender}\n${val.SenderGSTN}`,
        'SenderMobileNo^^SenderEmailID': `${val.SenderMobileNo}\n${val.SenderEmailID}`,
        'RecMobileNo^^ReceiverEmailID': `${val.RecMobileNo}\n${val.ReceiverEmailID}`,
        'RecName^^RecGSTN': `${val.RecName}\n${val.RecGSTN}`,
        'BkgDtTime^^UserBooked': `${moment(val.BkgDtTime).format('DD-MMM-YY HH:mm')}\n${val.UserBooked}`,
        'LRNO^^ManualLRNo': val.LRNO + '\n' + val.ManualLRNo,
        'DestCityName^^DestBranchName': val.DestCityName + '\n' + val.DestBranchName,
        'ConsignmentType^^Quantity': val.ConsignmentType + '\n' + val.Quantity,
        BookedResponse: val.BookedResponse ? JSON.parse(val.BookedResponse)?.TransID : '',
        DeliveredResponse: val.DeliveredResponse ? JSON.parse(val.DeliveredResponse)?.TransID : '',
      }))

    const summarize = (list) =>
      list.reduce((acc, val) => {
        acc.Quantity += +val.Quantity || 0;
        acc.Freight += +val.Freight || 0;
        acc.CartageAmount += +val.CartageAmount || 0;
        acc.HamaliCharges += +val.HamaliCharges || 0;
        acc.DocumentCharges += +val.DocumentCharges || 0;
        acc.Valuation += +val.Valuation || 0;
        acc.OtherCharges += +val.OtherCharges || 0;
        acc.BookingGST += +val.BookingGST || 0;
        acc.NetAmount += +val.NetAmount || 0;
        return acc;
      }, {
        Quantity: 0,
        Freight: 0,
        CartageAmount: 0,
        HamaliCharges: 0,
        DocumentCharges: 0,
        Valuation: 0,
        OtherCharges: 0,
        BookingGST: 0,
        NetAmount: 0,
      });

    const finalData = [];
    const grandTotal = {
      Quantity: 0,
      Freight: 0,
      CartageAmount: 0,
      HamaliCharges: 0,
      DocumentCharges: 0,
      Valuation: 0,
      OtherCharges: 0,
      BookingGST: 0,
      NetAmount: 0,
    };

    Object.entries(grouped).forEach(([key, list]) => {
      const [isRefund, paymentMode] = key.split('-');
      const transformed = transform(list);
      const summary = summarize(transformed);

      Object.keys(grandTotal).forEach(k => {
        grandTotal[k] += summary[k] || 0;
      });
      finalData.push({
        colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
        align: { [pickedHeaders[0]]: 'left', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
        [pickedHeaders[0]]: `Source City :${sourceCity?.SourceCityName}`,
        [pickedHeaders[1]]: `Destination City:${destinationCity?.DestCityName}`,
        [pickedHeaders[2]]: `Trans: ${isRefund === '0' ? 'Booked' : 'Refund'} | Payment Mode: ${paymentMode}`,
        dataType: 'subHeader',
      })
      finalData.push(...transformed);
      Object.keys(summary).forEach((k) => {
        summary[k] = Number(summary[k].toFixed(2))
      })
      finalData.push({
        ...summary,
        'ConsignmentType^^Quantity':summary.Quantity,
        colSpan:{[pickedHeaders[0]]: headers.findIndex((header) => header.field ==='ConsignmentType^^Quantity')},
        [pickedHeaders[0]]: `Total: Src.City ${sourceCity?.SourceCityName} / Dest.City ${destinationCity?.DestCityName}, Trans: ${isRefund === "0" ? "Booked" : "Refund"} | PaymentMode: ${paymentMode}`,
        dataType: 'total',
        align: { [pickedHeaders[0]]: 'right' },
        IsRefund: Number(isRefund),
      });
    });
    if (Object.keys(grouped).length > 1) {
      Object.keys(grandTotal).forEach((k) => {
        grandTotal[k] = Number(grandTotal[k].toFixed(2))
      })
      finalData.push({
        ...grandTotal,
        'ConsignmentType^^Quantity':grandTotal.Quantity,
        colSpan:{[pickedHeaders[0]]: headers.findIndex((header) => header.field ==='ConsignmentType^^Quantity')},
        [pickedHeaders[0]]: `Net Total: Src.City All Cities / Dest.City All Cities, Trans: Booked + Refund`,
        dataType: 'total',
        IsRefund: 0,
      })
    }
    

    return finalData;
  };
  const groupDataForLemya = (arr = []) => {
    const grouped = {};
    arr = arr.map((v, i) => ({
      ...v,
      Valuation: Math.round(v.Valuation) || 0,
      CartageAmount: Math.round(v.CartageAmount) || 0,
    }))
    arr.forEach((val) => {
      const key = `${val.IsRefund}-${val.PaymentMode}`;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(val);
    });
    const transform = (list) =>
      list.map((val, i) => ({
        ...val,
        srNo: i + 1,
        BkgDtTimeBy: `${moment(val.BkgDtTime).format("DD-MMM-YY HH:mm")}`,
        BookedResponse: val.BookedResponse ? JSON.parse(val.BookedResponse)?.TransID : '',
        DeliveredResponse: val.DeliveredResponse ? JSON.parse(val.DeliveredResponse)?.TransID : '',
      }));
    const summarize = (list) =>
      list.reduce((acc, val) => {
        acc.Quantity += +val.Quantity || 0;
        acc.Freight += +val.Freight || 0;
        acc.GoodsValue += +val.GoodsValue || 0;
        acc.Valuation += +val.Valuation || 0;
        acc.NetAmount += +val.NetAmount || 0;
        return acc;
      }, {
        Quantity: 0,
        Freight: 0,
        GoodsValue: 0,
        Valuation: 0,
        NetAmount: 0,
      });
    const finalData = [];
    const grandTotal = {
      Quantity: 0,
      Freight: 0,
      GoodsValue: 0,
      Valuation: 0,
      NetAmount: 0,
    };
    Object.entries(grouped).forEach(([key, list]) => {
      const [isRefund, paymentMode] = key.split('-');
      const transformed = transform(list);
      const summary = summarize(transformed);
      Object.keys(grandTotal).forEach(k => {
        grandTotal[k] += summary[k] || 0;
      });
      finalData.push({
        srNo: `Source City :${sourceCity?.SourceCityName}`,
        RecMobileNo: `Destination City:${destinationCity?.DestCityName}`,
        STATUS: `Trans: ${isRefund === "0" ? "Booked" : "Refund"} | Payment Mode: ${paymentMode}`,
        isSubHeading: true,
        dataType: 'header2',
        align:{srNo: 'left',RecMobileNo:'left',STATUS:'right' },
        colSpan: { srNo: 9,RecMobileNo:9,STATUS:10 }
      });
      finalData.push(...transformed);
      Object.keys(summary).forEach((k) => {
        summary[k] = Number(summary[k].toFixed(2))
      })
      finalData.push({
        ...summary,
        srNo: `Total: Src.City ${sourceCity?.SourceCityName} / Dest.City ${destinationCity?.DestCityName}, Trans: ${isRefund === "0" ? "Booked" : "Refund"} | PaymentMode: ${paymentMode}`,
        isTotal: true,
        dataType: 'total', colSpan: { srNo: 17 },
        IsRefund: Number(isRefund),
      });
    });
    Object.keys(grandTotal).forEach((k) => {
      grandTotal[k] = Number(grandTotal[k].toFixed(2))
    })
    finalData.push({
      ...grandTotal,
      srNo: `Net Total: Src.City All Cities / Dest.City All Cities, Trans: Booked + Refund`,
      isTotal: true,
      IsRefund: 0,
      dataType: 'total', colSpan: { srNo: 17 },
    });
    return finalData;
  };
  useEffect(() => {
    if (clickButton !== 'Generate') return

    const isDetailed = selReportView?.ReportView === 'Detailed'
    const isSummary = selReportView?.ReportView === 'Summary'

    if (isDetailed) {
      const raw = ownBookingTableData?.Data?.Table ?? []
      const headers = manageColumn.filter((obj) => obj.isSelected)
      if (raw.length === 0) {
        const noData = [
          {
            [headers[0].field]: 'No results found. Please refine your search parameters and search again.',
            dataType: 'total',
            colSpan: { [headers[0].field]: headers.length },
            align: { [headers[0].field]: 'center' },
          },
        ]
        setTableData(noData)
        return
      }
      let filtered = raw
      if (transactionType?.TransId === 1) {
        filtered = raw.filter((r) => r.IsRefund == 0)
      } else if (transactionType?.TransId === 2) {
        filtered = raw.filter((r) => r.IsRefund == 1)
      }
      const finalData = groupData(filtered, headers)
      if (finalData.length === 0) {
        const noData = [
          {
            [headers[0].field]: 'No results found. Please refine your search parameters and search again.',
            dataType: 'total',
            colSpan: { [headers[0].field]: headers.length },
            align: { [headers[0].field]: 'center' },
          },
        ]
        setTableData(noData)
      } else {
        setTableData(finalData)
      }
    }

    if (isSummary) {
      const tbl1 = ownBookingTableData?.Data?.Table1 ?? []
      if (tbl1.length === 0) {
        setTableData([]);
        return;
      }
      const colspans = devideInTwoIntegers(summaryheaders.length)
      const data = tbl1.map((v, i) => ({
        ...v,
        SN: i + 1,
        DocumentCharges: v.DocumentCharges || 0,
        Valuation: Math.round(v.Valuation) || 0,
        CartageAmount: Math.round(v.CartageAmount) || 0,
        dataType: 'entry',
      }))
      const totals = data.reduce(
        (t, v) => {
          if (v.isTotal || v.isHeading) return t
          t.LRCount += +v.LRCount || 0
          t.ItemUnits += +v.ItemUnits || 0
          t.Freight += +v.Freight || 0
          t.CartageAmount += +v.CartageAmount || 0
          t.HamaliCharges += +v.HamaliCharges || 0
          t.DocumentCharges += +v.DocumentCharges || 0
          t.Valuation += +v.Valuation || 0
          t.OtherCharges += +v.OtherCharges || 0
          t.BookingGST += +v.BookingGST || 0
          t.Amount += +v.Amount || 0
          t.RefundAmt += +v.RefundAmt || 0
          t.NetAmount += +v.NetAmount || 0
          return t
        },
        {
          LRCount: 0,
          ItemUnits: 0,
          Freight: 0,
          CartageAmount: 0,
          HamaliCharges: 0,
          DocumentCharges: 0,
          Valuation: 0,
          OtherCharges: 0,
          BookingGST: 0,
          Amount: 0,
          RefundAmt: 0,
          NetAmount: 0,
        }
      )
      Object.keys(totals).forEach((k) => {
        totals[k] = Number(totals[k].toFixed(2))
      })
      data.push({ ...totals, SN: 'Grand Total', dataType: 'total', colSpan: { SN: 2 } })
      const headerObject = summaryheaders.reduce(
        (acc, v) => {
          acc[v.field] = v.headerName
          return acc
        },
        { dataType: 'header' }
      )
      data.unshift(headerObject)
      data.unshift({
        [summaryheaders[0].field]: `Source City: ${sourceCity?.SourceCityName}`,
        [summaryheaders[colspans[0]].field]: `Destination City: ${destinationCity?.DestCityName}`,
        dataType: 'header2',
        colSpan: { SN: colspans[0], [summaryheaders[colspans[0]].field]: colspans[1] },
      })
      data.unshift({
        SN: `Booking Report`,
        dataType: 'header',
        colSpan: { SN: summaryheaders.length },
      })
      setTableData(data)
    }
  }, [clickButton, selReportView?.ReportView, ownBookingTableData, transactionType?.TransId,manageColumn])

useEffect(() => {
    focusElemnt('fromDate')
  }, [])

  // useEffect(()=>{
  //   focusElemnt(id.fromDate)
  // })
let Updatedcolumn = ownBookingDetailedColumnsWithFormattedLRTwo(UseFormattedLRinReports,loginCountryId,UseToPayAsCOD)
  useEffect(() => {
    const getLocalData = (key) => {
      return new Promise((resolve) => {
        const localData = localStorage.getItem(key)
        resolve(localData ? JSON.parse(localData) : null)
      })
    }
    const updateColumnDetails = async () => {
      try {
        if (BookingReportPortrait === 1) {
          let usedCols = []
          const ownBookingDetailedForPotrateCol = await getLocalData('ownBookingDetailedColumnsPotrate')
          usedCols = ownBookingDetailedForPotrateCol || ownBookingDetailedColumnsForPotrate

          if (UseFormattedLRinReports !== 3) {
            usedCols = usedCols.filter((item) => item.field !== 'FormattedLRNO')
          }
          if (!cargoSettingFilterData?.[0]?.IsHamaliInBookingReport) {
            usedCols = usedCols.filter((item) => !['HamaliCharges', 'DocumentCharges'].includes(item.field))
          }
          setManageColumn(usedCols)
        }else if(DefaultCurrencyID === 2){
         const UpdatedLeymacolumns = await getLocalData('ownBookingLeymaDetailedColumns2')
         let usedCols = UpdatedLeymacolumns || ownBookingDetailedColumnsForLeyma
         setManageColumn(usedCols)
        } else {
          const Updatedcolumns = await getLocalData('ownBookingDetailedColumns223')
          let usedCols = Updatedcolumns || Updatedcolumn
          usedCols = usedCols
            .map((col) => {
              if (DefaultCurrencyID === 2) {
                if (col.field === 'Valuation') {
                  return {
                    ...col,
                    header: 'Insu.\nChrg.',
                    exportHead: 'Insurance Charge',
                  }
                }
                if (col.field === 'Sender^^SenderGSTN') {
                  return {
                    ...col,
                    header: 'Sndr. Name',
                    exportHead: 'Sender Name',
                  }
                }
                if (col.field === 'RecName^^RecGSTN') {
                  return {
                    ...col,
                    header: 'Rcvr. Name',
                    exportHead: 'receiver Name',
                  }
                }
                if (col.field === 'BookingGST') {
                  return false
                }
              }
              if (col.field === 'CartageAmount' && intCompanyID === GT_COMPANY_ID) {
                return {
                  ...col,
                  header: 'Addl. \nCartage',
                  exportHead: 'Additional Cartage',
                }
              }
              return col
            })
            .filter(Boolean)
          setManageColumn(usedCols)
        }
      } catch (error) {
        setManageColumn([])
        console.error(error)
      }
    }

    updateColumnDetails()
  }, [UseFormattedLRinReports,BookingReportPortrait,loginCountryId,intCompanyID])
  const onSaveColumns = (items) => {
    setManageColumn(items)
    if (BookingReportPortrait===1) {
      localStorage.setItem('ownBookingDetailedColumnsPotrate', JSON.stringify(items))
    }else if(DefaultCurrencyID===2){
      // ownBookingDetailedColumnsForLeyma
      localStorage.setItem('ownBookingLeymaDetailedColumns2', JSON.stringify(items))
    }else{
        localStorage.setItem('ownBookingDetailedColumns223', JSON.stringify(items))
    }
  }
  const selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {}) || []
  const selectedSourceCity = (obj) => {
    setShowReport(false)
    setSourceCity(obj)
    setSourceBranch(removeDuplicatesFromArray(sourceBranchData, "SourceBranchID").filter((val) => val.SourceCityID === obj?.SourceCityID || obj?.SourceCityID === 0 || val.SourceBranchID === 0)?.[0])
  }

  const selectedSourceBranch = (obj) => {
    setShowReport(false)
    setSourceBranch(obj)
    setSourceBranchUser(removeDuplicatesFromArray(sourceBranchUserData, 'UserID')?.filter((val) => val?.SourceBranchID === obj?.SourceBranchID || obj?.SourceBranchID === 0 || val?.UserID === 0)?.[0])
  }
  const selectedDestCity = (obj) => {
    setShowReport(false)
    setDestinationCity(obj)
    setSelDestinationBranch(removeDuplicatesFromArray(destinationBranchdata, "DestBranchID").filter((val) => val.DestCityID === obj?.DestCityID || obj?.DestCityID === 0 || val.DestBranchID === 0)?.[0])
  }
  return (
    <>
      <Box sx={sx.reportFlex}>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            id="selectCompnay"
            label="Selected Company"
            data={ChildCompanyList}
            defaultvalue={selCompany?.CompanyName}
            disabled={AllowGroupofCompanies===1?false:true}
            onSelect={(val) => setSelCompany(val)}
            dataKey={`CompanyName`}
            idKey={`CompanyID`}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            value={fromDate}
            name={'from_booking_date'}
            dateDiff={365}
            // calcDiffDate(new Date(), new Date("2021,04,01"))
            label={lb.fromBookingDate}
            id={'fromDate'}
            nextId={'toDate'}
            prevId={'fromDate'}
            dateChange={(date) => { setFromDate(date); focusElemnt('toDate') }}
            width="170px"
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            value={toDate}
            name={'to_booking_date'}
            label={lb.toBookingDate}
            id={'toDate'}
            nextId={'OwnBookingGoBtn'}
            prevId={'fromDate'}
            dateChange={(date) => { setToDate(date); focusElemnt('OwnBookingGoBtn') }}
            width="170px"
          />
        </Item>
        <Item sx={sx.itemsx}>
          <Button
            id="OwnBookingGoBtn"
            variant="contained"
            className="go click-button"
            onClick={handleGoClick}
            onKeyDown={(e) => navigation3(e, 'sourceCity', 'fromDate', handleGoClick)}
          >
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label="Source City"
            id="sourceCity"
            nextId={'sourceBranch'}
            prevId={'OwnBookingGoBtn'}
            data={removeDuplicatesFromArray(sourceCityData, 'SourceCityID') || []}
            defaultvalue={sourceCity?.SourceCityName || sourceCity}
            dataKey={`SourceCityName`}
            idKey={`SourceCityID`}
            disabled={disableBtn}
            onSelect={(obj) => selectedSourceCity(obj)}
            width="170px"
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label="Source Branch"
            id="sourceBranch"
            nextId={'sourceBranchUser'}
            prevId={'sourceCity'}
            disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            // data={removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID') || []}
            data={
              removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID').filter(
                (val) => val.SourceCityID === sourceCity?.SourceCityID || sourceCity?.SourceCityID === 0 || val.SourceBranchID === 0
              ) || []
            }
            defaultvalue={sourceBranch?.SourceBranchName || sourceBranch}
            dataKey={`SourceBranchName`}
            idKey={`SourceBranchID`}
            onSelect={(val) => selectedSourceBranch(val)}
            width="170px"
            listWidth={'250px'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label="Source Branch User"
            id="sourceBranchUser"
            nextId={'destinationCity'}
            prevId={'sourceBranch'}
            disabled={loginData.intCompanyID===GT_COMPANY_ID?false:disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            defaultvalue={sourceBranchUser?.UserBooked || sourceBranchUser}
            data={
              removeDuplicatesFromArray(sourceBranchUserData, 'UserID')?.filter(
                (val) => val?.SourceBranchID === sourceBranch?.SourceBranchID || sourceBranch?.SourceBranchID === 0 || val?.UserID === 0
              ) || []
            }
            dataKey={`UserBooked`}
            idKey={`UserID`}
            onSelect={(val) => {
              setShowReport(false)
              setSourceBranchUser(val)
            }}
            width="170px"
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label="Destination City"
            id="destinationCity"
            nextId={'destinationBranch'}
            prevId={'sourceBranchUser'}
            defaultvalue={destinationCity?.DestCityName || destinationCity}
            data={
              removeDuplicatesFromArray(destinationCityData, 'DestCityID').filter(
                (val) => val.DestCityID !== sourceCity?.SourceCityID || val.DestCityID === 0
              ) || []
            }
            dataKey={`DestCityName`}
            idKey={`DestCityID`}
            onSelect={(obj) => selectedDestCity(obj)}
            width="170px"
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label="Destination Branch"
            id="destinationBranch"
            nextId={'paymentType'}
            prevId={'destinationCity'}
            defaultvalue={destinationBranch?.DestBranchName || destinationBranch}
            data={
              removeDuplicatesFromArray(destinationBranchdata, 'DestBranchID').filter(
                (val) => val.DestCityID === destinationCity?.DestCityID || destinationCity?.DestCityID === 0 || val.DestBranchID === 0
              ) || []
            }
            dataKey={`DestBranchName`}
            idKey={`DestBranchID`}
            onSelect={(obj) => {
              setShowReport(false)
              setSelDestinationBranch(obj)
            }}
            width="170px"
            listWidth={'250px'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label={'Payment Type'}
            // data={paymentModesWithAll || []}
            data={(paymentModesWithAll || []).map((item) => {
              if (UseToPayAsCOD === 1) {
                if (item.typeId === 2) {
                  return { ...item, name: 'COD' };
                }
                if (item.typeId === 7) {
                  return { ...item, name: 'COD Manual' };
                }
                if (item.typeId === 9) {
                  return { ...item, name: 'COD DDDV' };
                }
                if (item.typeId === 4) {
                  return null;
                }
              }
              return item;
            }).filter(Boolean)
            }
            id="paymentType"
            nextId={'TransactionType'}
            prevId={'destinationBranch'}
            defaultvalue={paymentType?.name || ''}
            width="100%"
            searchPlaceholder={`Search By Payment Type`}
            tabIndex="2"
            dataKey={`name`}
            idKey={`typeId`}
            onSelect={(val) => {
              setShowReport(false)
              setPaymentType(val)
            }}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label="Txn.Type"
            id="TransactionType"
            nextId={'ReportView'}
            prevId={'paymentType'}
            defaultvalue={transactionType?.TransType || ''}
            data={transType}
            onSelect={(val) => {
              setShowReport(false)
              setTransactionType(val)
            }}
            dataKey={`TransType`}
            idKey={`TransId`}
            width="170px"
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id="ReportView"
            nextId={'LrStatus'}
            prevId={'TransactionType'}
            label="Report View"
            data={reportView}
            defaultvalue={selReportView?.ReportView || ''}
            dataKey={`ReportView`}
            onSelect={(val) => {
              setShowReport(false)
              setSelReportView(val)
            }}
            idKey={`ReportId`}
            width="170px"
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id="LrStatus"
            nextId={'OwnChechBox'}
            prevId={'ReportView'}
            label="LR Status"
            data={lrStatusView}
            defaultvalue={status?.LrStatus || ''}
            dataKey={`LrStatus`}
            idKey={`LrId`}
            width="170px"
            listWidth={'250px'}
            onSelect={(val) => {
              setShowReport(false)
              setStatus(val)
            }}
          />
        </Item>
        <FormControlLabel
          value="end"
          id="OwnChechBox"
          prevId={'LrStatus'}
          nextId={"OwnSplitBtn"}
          control={<Checkbox id={id.onlyRefund} />}
          className={`${checkCrossinglr ? 'selcheck' : 'unselcheck'}`}
          label="Include Crossing LRs?"
          labelPlacement="end"
          checked={checkCrossinglr}
          onChange={() => {
            setCheckCrossinglr(!checkCrossinglr)
          }}
          onKeyDown={(e) => {
            navigation3(e, 'OwnSplitBtn', 'LrStatus')
          }}
        />

        <Item
          sx={sx.itemsx}
          style={{ cursor: 'pointer' }}
          // onKeyDown={(e) => navigation3(e, showReport ? 'test-table-xls-button' : 'fromDate', 'reportView', () => handleClick1())}
          onKeyDown={(e) => navigation3(e, showReport ? disableExcel ? "OwnBookingReportPdfBtn" : "ExpToExlbtn" : 'fromDate', 'OwnChechBox', () => handleClick1())}
        >
          {/* id.anlsFromDate */}
          <SplitButton
            // options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
            // hideToggle={true}
            // id={id.anSplitButton}
            id1={'OwnSplitBtn'}
            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
            // hideToggle={true}
            prevID={id.summaryCheck}
            onClick1={handleClick1}
            onClick2={handleClick2}
          />
        </Item>
        <Item sx={sx.itemsx} className="flex-center-all" onClick={reset}>
          <RefreshSvg />
        </Item>
      </Box>
      <Box>
        {showReport ? (
          selReportView?.ReportView === 'Summary' ? (
            <OwnBookingSummary
              UseToPayAsCOD={UseToPayAsCOD}
              tableData={tableData}
              headers={summaryheaders}
              checkCrossinglr={checkCrossinglr}
              cargoSettingFilterData={cargoSettingFilterData?.[0]?.IsHamaliInBookingReport}
              disableExcel={disableExcel}
              fromDate={fromDate}
              loginData={loginData}
              toDate={toDate}
              sourceCity={sourceCity}
              sourceBranch={sourceBranch}
              sourceBranchUser={sourceBranchUser}
              destinationCity={destinationCity}
              destinationBranch={destinationBranch}
              paymentType={paymentType}
              transactionType={transactionType}
              selReportView={selReportView}
              status={status}
            />
          ) : (
            <OwnBookingDetailed
              BookingReportPortrait={BookingReportPortrait}
              tableData={tableData}
              headerData={headerData}
              checkCrossinglr={checkCrossinglr}
              cargoSettingFilterData={cargoSettingFilterData?.[0]?.IsHamaliInBookingReport}
              disableExcel={disableExcel}
              fromDate={fromDate}
              loginData={loginData}
              toDate={toDate}
              sourceCity={sourceCity}
              sourceBranch={sourceBranch}
              sourceBranchUser={sourceBranchUser}
              destinationCity={destinationCity}
              destinationBranch={destinationBranch}
              paymentType={paymentType}
              transactionType={transactionType}
              selReportView={selReportView}
              status={status}
              updateModal={updateModal}
              columnSummaryDefs={manageColumn.filter((obj) => obj.isSelected)}
              columnSummaryDefsForExcel={OwnBookingDetailedExcelHeader.filter(col => selectedFields?.[col.field]).map(col => {
                  if (loginCountryId === 2 && col.field === 'Valuation') {
                    return { ...col, header: 'Insurance Charge' };
                  }
                  return col;
                })
              }
              // columnSummaryDefsForExcel={OwnBookingDetailedExcelHeader.filter((val) => selectedFields[val.field])}
              selectedFields={selectedFields}
              UseFormattedLRinReports={UseFormattedLRinReports}
            />
            
          )
        ) : (
          ''
        )}
      </Box>
      {showModal && modalType === 'ownBookingShowManageColumn' && (
        <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} />
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnBookingFilterData, getOwnBookingTableData, getCargoSettingFilterData, updateAlert, updateAlertError, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(OwnBookings)
